import type { LocationsResources } from '../en/locations';

export const locations: LocationsResources = {
  list: {
    title: 'Standorte',
    loading: 'Standorte werden geladen …',
    error: 'Standorte konnten nicht geladen werden.',
    searchPlaceholder: 'Nach Name, Adresse oder Stadt suchen…',
    actions: {
      add: 'Standort hinzufügen',
      editLabel: 'Bearbeiten',
      edit: '{{name}} bearbeiten',
    },
    columns: {
      name: 'Name',
      street: 'Straße',
      houseNumber: 'Hausnummer',
      addressDetails: 'Adresszusatz',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      stateRegion: 'Bundesland / Region',
      country: 'Land',
      actions: 'Aktionen',
    },
    result: {
      singular: 'Standort',
      plural: 'Standorte',
    },
    filters: {
      countryHint: 'Nach den Ländern filtern, in denen Standorte liegen.',
    },
    empty: {
      title: 'Noch keine Standorte',
    },
    noResults: {
      title: 'Keine Standorte gefunden',
      description: 'Passen Sie Suche oder Filter an, um wieder Ergebnisse zu sehen.',
      reset: 'Suche und Filter zurücksetzen',
    },
  },
  dialog: {
    addTitle: 'Neuen Standort hinzufügen',
    editTitle: '{{name}} bearbeiten',
    loading: 'Wird geladen …',
    loadError: 'Dieser Standort konnte nicht geladen werden.',
  },
  form: {
    fields: {
      name: 'Name',
      street: 'Straße',
      houseNumber: 'Hausnummer',
      addressDetails: 'Adresszusatz',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      stateRegion: 'Bundesland / Region',
      countryCode: 'Land',
    },
    placeholders: {
      name: 'Büro München',
      street: 'Zielstattstraße',
      houseNumber: '13',
      addressDetails: '2. Etage',
      postalCode: '81379',
      city: 'München',
      stateRegion: 'Bayern',
    },
    validation: {
      required: 'Dieses Feld ist erforderlich',
    },
    country: {
      search: 'Land suchen…',
      noMatch: 'Kein Land gefunden',
    },
    actions: {
      save: 'Speichern',
      saving: 'Speichern …',
      cancel: 'Abbrechen',
    },
  },
  toast: {
    created: 'Standort erstellt',
    updated: 'Änderungen gespeichert',
    saveFailed: 'Standort konnte nicht gespeichert werden. Bitte erneut versuchen.',
  },
};
